import * as React from "react";
type Props = {
  className?: string,
};
function SvgIllustratedMagnifyingGlass({ className }: Props) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-illustratedMagnifyingGlass"
      className={className}
    >
      <path
        d="M24.7228 28.2876C30.0343 25.2209 31.8542 18.429 28.7876 13.1175C25.7209 7.80588 18.929 5.986 13.6175 9.05264C8.30589 12.1193 6.48601 18.9112 9.55265 24.2228C12.6193 29.5343 19.4112 31.3542 24.7228 28.2876Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M43.3063 39.5412L43.4834 39.3348C44.2985 38.3849 44.1891 36.9541 43.2392 36.139L36.3591 30.2358C35.4091 29.4207 33.9783 29.53 33.1632 30.48L32.9861 30.6864C32.1711 31.6363 32.2804 33.0672 33.2304 33.8822L40.1105 39.7855C41.0604 40.6005 42.4913 40.4912 43.3063 39.5412Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M28.3594 24.9318L33.8735 29.6777L32.2681 31.5205L26.6786 26.8705"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M23.1701 25.5987C26.9966 23.3895 28.3076 18.4965 26.0984 14.67C23.8892 10.8435 18.9962 9.53248 15.1697 11.7417C11.3432 13.9509 10.0321 18.8439 12.2414 22.6704C14.4506 26.4969 19.3436 27.8079 23.1701 25.5987Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M16.8829 23.3666C16.5053 23.1659 15.1838 22.4633 14.4992 20.8697C13.6385 18.8804 14.4036 17.0779 14.5175 16.7766"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M35.5032 9.80008C35.023 9.80008 34.6337 10.2045 34.6337 10.7033V11.6066H33.7641C33.2838 11.6066 32.8945 12.0109 32.8945 12.5098C32.8945 13.0086 33.2838 13.413 33.7641 13.413H34.6337V14.3163C34.6337 14.8151 35.023 15.2195 35.5032 15.2195C35.9835 15.2195 36.3728 14.8151 36.3728 14.3163V13.413H37.2424C37.7226 13.413 38.1119 13.0086 38.1119 12.5098C38.1119 12.0109 37.7226 11.6066 37.2424 11.6066L36.3728 11.6066V10.7033C36.3728 10.2045 35.9835 9.80008 35.5032 9.80008Z"
        fill="currentColor"
      />
      <path
        d="M39.4163 14.3163C39.0161 14.3163 38.6916 14.6533 38.6916 15.069V15.8217H37.967C37.5668 15.8217 37.2424 16.1587 37.2424 16.5744C37.2424 16.9901 37.5668 17.3271 37.967 17.3271H38.6916V18.0797C38.6916 18.4955 39.0161 18.8324 39.4163 18.8324C39.8165 18.8324 40.1409 18.4955 40.1409 18.0797V17.3271H40.8656C41.2658 17.3271 41.5902 16.9901 41.5902 16.5744C41.5902 16.1587 41.2658 15.8217 40.8656 15.8217H40.1409V15.069C40.1409 14.6533 39.8165 14.3163 39.4163 14.3163Z"
        fill="currentColor"
      />
      <path
        d="M12.5032 35.8001C12.023 35.8001 11.6337 36.2045 11.6337 36.7033V37.6066H10.7641C10.2838 37.6066 9.89453 38.0109 9.89453 38.5098C9.89453 39.0086 10.2838 39.413 10.7641 39.413H11.6337V40.3163C11.6337 40.8151 12.023 41.2195 12.5032 41.2195C12.9835 41.2195 13.3728 40.8151 13.3728 40.3163V39.413H14.2424C14.7226 39.413 15.1119 39.0086 15.1119 38.5098C15.1119 38.0109 14.7226 37.6066 14.2424 37.6066L13.3728 37.6066V36.7033C13.3728 36.2045 12.9835 35.8001 12.5032 35.8001Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIllustratedMagnifyingGlass;
